import { createAction, props, union } from '@ngrx/store';
import { HttpParams } from '@angular/common/http';
import { ElateList } from '../../model/elate.model';

export enum ElateActionTypes {
  GET_LISTING = '[ELATE] Get LISTING',
  GET_LISTING_URL = '[ELATE] Get LISTING URL',
  GET_LISTING_SUCCESS = '[ELATE] Get LISTING Success',
  GET_LISTING_FAILURE = '[ELATE] Get LISTING Failure',
  GET_ONE = '[ELATE] Get ONE',
  GET_ONE_SUCCESS = '[ELATE] Get ONE Success',
  GET_ONE_FAILURE = '[ELATE] Get ONE Failure',
}

export const GetElatesListing = createAction(
  ElateActionTypes.GET_LISTING,
  props<{ params: HttpParams }>()
);

export const GetElatesListingfromurl = createAction(
  ElateActionTypes.GET_LISTING_URL,
  props<{ url: string }>()
);

export const GetElatesListingSuccess = createAction(
  ElateActionTypes.GET_LISTING_SUCCESS,
  props<{ payload: ElateList }>()
);

export const GetElatesListingFailure = createAction(
  ElateActionTypes.GET_LISTING_FAILURE,
);

export const GetElate = createAction(
  ElateActionTypes.GET_ONE,
  props<{ id: string }>()
);

export const GetElateSuccess = createAction(
  ElateActionTypes.GET_ONE_SUCCESS,
  props<{ payload: any }>() // TODO: Replace any by Elate when model complete
);

export const GetElateFailure = createAction(
  ElateActionTypes.GET_ONE_FAILURE,
);

const actions = union({
  GetElatesListing,
  GetElatesListingfromurl,
  GetElatesListingSuccess,
  GetElatesListingFailure,
  GetElate,
  GetElateSuccess,
  GetElateFailure
});

export type ElateActionsUnions = typeof actions;
